import { useMemo } from 'react';
import { compose } from 'redux';
import { considerRichContent, considerSimpleContent } from '../../utils';

export const useSimpeContentValidation = (text) => {
    const { isPassing } = useMemo(() => compose(considerRichContent, considerSimpleContent)({ text, isPassing: true }), [text]);
    return isPassing;
};
